<div>
  @if (added.length) {
    <p>
      <strong>{{
        'page.settings.company_settings.activity_categories_confirm_added'
          | translate
      }}</strong>
      {{ addedNames }}
    </p>
  }
  @if (removed.length) {
    <p>
      <strong>{{
        'page.settings.company_settings.activity_categories_confirm_removed'
          | translate
      }}</strong>
      {{ removedNames }}
    </p>
  }
  <p>
    {{
      'page.settings.company_settings.activity_categories_payroll_warning'
        | translate
    }}
  </p>
  @if (hasPayableTimeAdded) {
    <p>
      {{
        'page.settings.company_settings.activity_categories_payroll_hint'
          | translate
      }}
    </p>
  }
  <p>
    <a [href]="handbookUrl" target="_blank" rel="noopener">{{
      'page.settings.company_settings.activity_categories_warning_link'
        | translate
    }}</a>
  </p>
</div>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="cancel()">
    {{ 'general.cancel' | translate }}
  </button>
  <button nz-button nzType="primary" (click)="confirm()">
    {{ 'general.accept' | translate }}
  </button>
</div>
